import React from "react";
import { Button, Result } from "antd";

const Loading = ({ percent = 10, hasError, findLawyer }) => {
  function getClass() {
    if (percent < 20) {
      return "very-low";
    } else if (percent <= 35) {
      return "low";
    } else if (percent <= 50) {
      return "mid";
    } else if (percent <= 75) {
      return "high";
    } else if (percent <= 100) {
      return "very-high";
    }
  }

  return (
    <>
      {hasError ? (
        <div>
          <Result
            status="warning"
            title="در جستجوی وکیل با خطا مواجه شدیم"
            extra={
              <Button type="primary" key="console" onClick={() => findLawyer()}>
                تلاش دوباره
              </Button>
            }
          />
        </div>
      ) : (
        <div className="loading-holder">
          <div className="loading-circle">
            <div className={`loading-wave ${getClass()}`}>
              <span className="percent-text"> {percent}% </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Loading;
